'use strict';


var novicell = novicell || {};
var sliderMinYear = sliderMinYear || null;
var sliderMaxYear = sliderMaxYear || null;
var historicsNames = historicsNames || null;
var historicsValues = historicsValues || null;
var annualReturnsNames = annualReturnsNames || null;
var annualReturnsValues = annualReturnsValues || null;

novicell.productReturnGraphs = novicell.productReturnGraphs || new function () {
    
    var mainColorRGB='0, 104, 144';
    var arrMainColorOpacities=['1'];
    var objMainColorsRgba={};
    const sliderBus = new Vue();
    
    this.initBarChartSlider = function (barGraphSliderContainer){
        new Vue( {
            el: barGraphSliderContainer,
            data () {
                return {
                    value:[sliderMinYear,sliderMaxYear],
                    options: {
                        data: null,
                        eventType: 'auto',
                        width: 'auto',
                        height: 6,
                        dotSize: 16,
                        dotHeight: null,
                        dotWidth: null,
                        min: sliderMinYear,
                        max: sliderMaxYear,
                        interval: 1,
                        show: true,
                        speed: 0.5,
                        disabled: false,
                        piecewise: false,
                        usdKeyboard: false,
                        enableCross: true,
                        piecewiseLabel: false,
                        piecewiseActiveStyle: null,
                        tooltip: 'always',
                        tooltipDir: 'top',
                        reverse: false,
                        clickable: true,
                        realTime: false,
                        lazy: false,
                        formatter: null,
                        sliderStyle: null,
                        labelStyle: null,
                        labelActiveStyle: null,
                        bgStyle: {
                            "backgroundColor": "#f2f2f2",
                        },
                        tooltipStyle: {
                            
                            "backgroundColor": objMainColorsRgba.o1,
                            "borderColor": objMainColorsRgba.o1,
                            'padding':'0 3px',
                            'lineHeight':1.3
                        },
                        processStyle: {
                            "backgroundColor": objMainColorsRgba.o1
                        }
                    }
                };
            },
            methods: {
                sliderChange (v) {
                    sliderBus.$emit('sliderValueChange',v);
                }
            },
            components: {
                'vueSlider': window[ 'vue-slider-component' ],
            }
        });
    };
    this.initLineChart = function (graphContainer) {
        Vue.component('line-chart', {
            extends: VueChartJs.Line,
            props: ['options'],
            mixins: [VueChartJs.mixins.reactiveProp],
            mounted () {
                this.renderChart(this.chartData, this.options);
            }
        });
        var latestYear=0;
        
        var vm = new Vue({
            el: graphContainer,
            data: {
                show: true,
                message: {},
                options: {
                    tooltips: {
                        // Disable the on-canvas tooltip
                        enabled: false,
                        
                        custom: function(tooltipModel) {
                            // Tooltip Element
                            var tooltipEl = document.getElementById('chartjs-tooltip');
                            
                            var innerHtml = '';
                            
                            // Create element on first render
                            if (!tooltipEl) {
                                tooltipEl = document.createElement('div');
                                tooltipEl.id = 'chartjs-tooltip';
                                tooltipEl.innerHTML = "<div></div>";
                                document.body.appendChild(tooltipEl);
                            }
                            
                            // Hide if no tooltip
                            if (tooltipModel.opacity === 0) {
                                tooltipEl.style.opacity = 0;
                                return;
                            }
                            
                            // Set caret Position
                            tooltipEl.classList.remove('above', 'below', 'no-transform');
                            if (tooltipModel.yAlign) {
                                tooltipEl.classList.add(tooltipModel.yAlign);
                            } else {
                                tooltipEl.classList.add('no-transform');
                            }
                            
                            function getBody(bodyItem) {
                                return bodyItem.lines;
                            }
                            
                            // Set Text
                            if (tooltipModel.body) {
                                var titleLines = tooltipModel.title || [];
                                var bodyLines = tooltipModel.body.map(getBody);
                                
                                bodyLines.forEach(function(body, i) {//value
                                    body=body[0]*1;
                                    var float=Math.round(body);
                                    var string = float.toString();
                                    string = string.replace(/\B(?=(\d{3})+(?!\d))/g, '#');
                                    string = string.replace(/\./g, ',');
                                    string = string.replace(/#/g, '.');
                                    innerHtml += '<span style="left: calc(50% - 10px);display:block;position:absolute;top:100%;width: 0;height: 0;border-style: solid;border-width: 10px 10px 0 10px;border-color: #b3b1b3 transparent transparent transparent;"></span><b style="display:block;font-size:15px;">' + string + '</b>';
                                });
                                
                                titleLines.forEach(function(title) {
                                    innerHtml += '<span style="display:block;font-size:13px;">' + title + '</span>';
                                });
                                
                                var tableRoot = tooltipEl.querySelector('div');
                                tableRoot.innerHTML = innerHtml;
                            }
                            
                            // `this` will be the overall tooltip
                            var position = this._chart.canvas.getBoundingClientRect();
                            
                            // Display, position, and set styles for font
                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                            tooltipEl.style.background = '#b3b1b3';
                            tooltipEl.style.WebkitTransform = 'translate(-50%,-100%)';
                            tooltipEl.style.transform = 'translate(-50%,-100%)';
                            tooltipEl.style.margin = '-20px 0 0 0';
                            tooltipEl.style.borderRadius = '3px';
                            tooltipEl.style.textAlign = 'center';
                            tooltipEl.style.padding = '3px 5px';
                            tooltipEl.style.pointerEvents = 'none';
                            tooltipEl.style.color = '#fff';
                        }
                    },
                    hover: {
                        mode: 'nearest',
                        intersect: true
                    },
                    responsive: true,
                    animation: {
                        duration:1000
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                //max: Math.max(...hhh)*1.13,
                            },
                            gridLines : {
                                drawBorder : false,
                                color:'#eee',
                                zeroLineColor: '#eee',
                                lineWidth:1,
                                zeroLineWidth:2
                            }
                        }],
                        xAxes: [{
                            /* 
                            display:false,
                            ticks: {
                                display : false
                            },
                            */
                            gridLines : {
                                display: false,
                                drawBorder : false
                            } 
                        }]
                    },
                    legend: {
                        display: false
                    },
                    layout: {
                        padding: {
                            top: 5
                        }
                    }
                },
                availableLabels: historicsNames,
                availableData: historicsValues,// 60 values since it's 5 years...?
                availableMonths:[],
                selectOne: '60',
                selectOptions:{
                    months: ['Januar','Februar','Marts','April','Maj','Juni','Juli','August','September','Oktober','November','December'],
                    years:[]
                },
                labelStartTime:'Starttidspunkt',
                labelEndTime:'Sluttidspunkt',
                selectErrors:[]
            },
            computed:{
                getSizes:function(){
                    let obj={width:27,height:10};
                    if (window.matchMedia("(max-width: 479px)").matches) {
                        obj.height=17;
                    }
                    return obj;
                },
                selectValues:function(){
                    var obj = {
                        startYear:'',
                        endYear:'',
                        startMonth:'',
                        endMonth:''
                    };
                    return obj;
                },
                formattedSelectErrors:function(){
                    if(this.selectErrors.length){
                        var strHtml = '<ul class="product-return-graphs__selects-errors">';
                        for(var i = 0 ; i < this.selectErrors.length ; i++){
                            strHtml += '<li>'+this.selectErrors[i]+'</li>';
                        }
                        strHtml += '</ul>';
                        return strHtml;
                    }
                    return '';
                },
                returnInPeriodInfoValue:function(){
                    // Afkast i perioden: (slutværdi / startværdi -1) * 100
                    var obj={};
                    if(this.message.datasets != undefined){
                        let arrData = this.message.datasets[0].data;
                        let first = parseFloat(arrData[0]);
                        let last = parseFloat(arrData[arrData.length - 1]);
                        let returnPeriod = ((last / first) - 1) * 100;
                        let formattedReturnPeriod = this.formatFloatToDanishFloat(returnPeriod);
                        obj = {
                            returnFloat: returnPeriod,
                            returnFormatted: formattedReturnPeriod+' %',
                            firstValue:first,
                            lastValue:last,
                            return: returnPeriod
                        };
                    }
                    return obj;
                },
                returnPerYearInfoValue:function(){
                    var obj={};
                    if(this.returnInPeriodInfoValue.returnFloat != undefined){
                        let monthsAmount = this.message.datasets[0].data.length -1;

                        var years = monthsAmount / 12;
                        var gain = (this.returnInPeriodInfoValue.returnFloat / 100) +1;
                        var power = 1 / years;
            
                        var gain2 = Math.pow(1 + (gain - 1), power) - 1;
                        gain2 = gain2 * 100;

                        let returnPerYear = gain2;
                        let formattedReturnPerYear = this.formatFloatToDanishFloat(gain2);

                        obj = {
                            returnFloat: returnPerYear,
                            returnFormatted: formattedReturnPerYear+' %'
                        };
                    }
                    return obj;
                }
            },
            mounted () {
                this.makeAvailableMonths();
                this.makeSelectValues();
                this.fillData();
                
            },
            methods: {
                formatFloatToDanishFloat: function(float){/**format number to have 2 decimals and use danish notation, for instance 3.456.789,01 */
                    float=float.toFixed(2);
                    var string = float.toString();
                    string = string.replace(/\B(?=(\d{3})+(?!\d))/g, '#');
                    string = string.replace(/\./g, ',');
                    string = string.replace(/#/g, '.');
                    return string;
                },
                findIndexOfChosenSelectValue (isEndIndex,currMonth,currYear){
                    var currIndex = -1;
                    for (var i = 0; i < this.availableLabels.length; ++i) {
                        let monthWidthPadStart = currMonth.toString().length==1?'0'+currMonth : currMonth;
                        let stringString = monthWidthPadStart+'-'+currYear;
                        if (this.availableLabels[i].substring(3,10) == stringString) {
                            currIndex = i;
                            break;
                        }
                    }
                    if(isEndIndex){
                        currIndex++;
                    }
                    return currIndex;
                },
                fillData () {
                    if(!this.selectErrors.length){
                        var startIndex = this.findIndexOfChosenSelectValue(false,parseInt(this.selectValues.startMonth),this.selectValues.startYear);
                        var endIndex = this.findIndexOfChosenSelectValue(true,parseInt(this.selectValues.endMonth),this.selectValues.endYear);
                        var self = this;
                        
                        let newLabels = this.availableLabels.slice(startIndex,endIndex);
                        let newData = this.availableData.slice(startIndex,endIndex);
                        var newIndex100 = newData[0];
                        newData = newData.map(function(item){
                            // recalculate so the new selection starts at index 100
                            return (item / newIndex100) * 100;
                        });
                        // var ctx=this.$children[0]._data._chart.ctx;
                        this.message = {
                            labels: newLabels,
                            datasets: [
                                {
                                    data: newData,
                                    backgroundColor: 'rgba(0,0,0,0)',
                                    borderColor: objMainColorsRgba.o1,
                                    borderWidth: 3,
                                    pointBorderWidth: 0,
                                    pointRadius:2,
                                    lineTension:0
                                }
                            ]
                        };
                    }
                },
                makeAvailableMonths () {
                    for(var i = 0 ; i < this.availableLabels.length ; i++){
                        let currentDateString = this.availableLabels[i];
                        let year = currentDateString.substring(6,10);
                        let month = currentDateString.substring(3,5);
                        let currentDate = new Date(year, month, 0, 0, 0, 0, 0);
                        this.availableMonths.push(currentDate);
                    }
                },
                makeSelectValues () {
                    var firstYear = this.availableLabels[0].substring(6,10);
                    var lastYear = this.availableLabels[this.availableLabels.length - 1].substring(6,10);
                    var firstMonth = this.availableLabels[0].substring(3,5) ;
                    var lastMonth = this.availableLabels[this.availableLabels.length - 1].substring(3,5) ;
                    for(var i = firstYear ; i <=lastYear; i++){
                        this.selectOptions.years.push(i);
                    }
                    this.selectValues.startMonth = parseInt(firstMonth);
                    this.selectValues.endMonth = parseInt(lastMonth);
                    this.selectValues.startYear = parseInt(firstYear);
                    this.selectValues.endYear = parseInt(lastYear);
                },
                selectChange () {
                    this.selectErrors=[];//reset errors
                    
                    // check if dates are within range
                    let startTimeError = this.getDateIsSelectableError(this.selectValues.startMonth,this.selectValues.startYear,this.labelStartTime);
                    if(startTimeError){
                        this.selectErrors.push(startTimeError);
                    }
                    
                    let endTimeError = this.getDateIsSelectableError(this.selectValues.endMonth,this.selectValues.endYear,this.labelEndTime);
                    if(endTimeError){
                        this.selectErrors.push(endTimeError);
                    }
                    
                    // check if last date is later or same as first date
                    let currStartDate = new Date(this.selectValues.startYear, this.selectValues.startMonth, 0, 0, 0, 0, 0);
                    let currEndDate = new Date(this.selectValues.endYear, this.selectValues.endMonth, 0, 0, 0, 0, 0);
                    if(currStartDate > currEndDate){
                        this.selectErrors.push('Det valgte '+this.labelStartTime.toLowerCase()+' skal ligge før det valgte '+this.labelEndTime.toLowerCase());
                    }
                    
                    // update graph
                    this.fillData();
                    if(this.selectErrors.length){
                        
                    }
                    
                },
                getDateIsSelectableError (chosenMonth, chosenYear,labelName){
                    let currMonth = parseInt(chosenMonth);
                    let currYear = parseInt(chosenYear);
                    let currDate = new Date(currYear, currMonth, 0, 0, 0, 0, 0);
                    let startIdx = this.availableMonths.map(Number).indexOf(+currDate); 
                    if(startIdx == -1){
                        // date not available
                        let firstAvailableMonth = this.selectOptions.months[this.availableMonths[0].getMonth()];
                        let lastAvailableMonth = this.selectOptions.months[this.availableMonths[this.availableMonths.length-1].getMonth()];
                        let firstAvailableYear = this.availableMonths[0].getFullYear();
                        let lastAvailableYear = this.availableMonths[this.availableMonths.length-1].getFullYear();
                        return labelName+' ligger uden for den tilgængelige periode, som er mellem '+firstAvailableMonth.toLowerCase()+' ' + firstAvailableYear +' og '+lastAvailableMonth.toLowerCase()+' '+lastAvailableYear;
                    }
                    return false;
                }
            }
        });
        
    };
    this.setColors = function(barGraphContainer){
        // color for graphs = button color
        
        let testButton = document.createElement('button');
        testButton.id = 'js-testButton';
        testButton.classList.add('theme-button');
        testButton.setAttribute('style','position:fixed;left:-3333px;');
        barGraphContainer.appendChild(testButton);
        let colorString = getComputedStyle(document.getElementById('js-testButton')).backgroundColor;
        colorString = colorString.replace('rgb(','');
        colorString = colorString.replace(')','');
        mainColorRGB = colorString;
        for(var i = 0 ; i < arrMainColorOpacities.length ; i++){
            objMainColorsRgba['o'+arrMainColorOpacities[i]] = 'rgba('+mainColorRGB+','+arrMainColorOpacities[i]+')';
        }
    };
    this.init = function () {
        const barGraphContainer = document.getElementById('js-product-return-bar-graphs-container');
        if (barGraphContainer == null) {
            return;
        }
        this.setColors(barGraphContainer);
        
        
        this.initBarChart(barGraphContainer);
        //
        const barGraphSliderContainer = document.getElementById('js-product-return-bar-graphs-slider-container');
        if (barGraphSliderContainer == null) {
            return;
        }
        this.initBarChartSlider(barGraphSliderContainer);
        
        const graphContainer = document.getElementById('js-product-return-graphs-container');
        if (graphContainer == null) {
            return;
        }
        this.initLineChart(graphContainer);
        
        const printLinks = document.getElementsByClassName('product-return-graphs__print-link');
        if (!printLinks.length) {
            return;
        }
        this.initPrintLinks(printLinks);
    };
    this.initPrintLinks = function (printLinks) {
        for(var i = 0; i < printLinks.length ; i++){
            printLinks[i].addEventListener('click',function(e){
                e.preventDefault();
                window.print();
            });
        }
    };
    this.initBarChart = function (graphContainer) {
        Vue.component('bargraph', {
            extends: VueChartJs.Bar,
            mixins: [VueChartJs.mixins.reactiveProp],
            props: ['options'],
            mounted () {
                this.renderChart(this.chartData, this.options);
            }
        });
        
        var vm2 = new Vue({ 
            el: graphContainer,
            data () {
                return {
                    datacollection: null,
                    availableYears: annualReturnsNames,
                    availableValues: annualReturnsValues
                };
            },
            created () {
                this.fillData2([Math.min(...this.availableYears),Math.max(...this.availableYears)]);
                sliderBus.$on('sliderValueChange', this.fillData2);
            },
            computed:{
                options: function(){
                    let self = this;
                    var obj = {
                        responsive: true, 
                        maintainAspectRatio: false,
                        animation: {
                            duration:800,
                            onProgress: function () {// for performance sake, this ought to be onComplete, but then the labels disappears for a too long time before being redrwn, when you hover
                                self.makeLegends();
                            },
                            onComplete: function () {// for performance sake, this ought to be onComplete, but then the labels disappears for a too long time before being redrwn, when you hover
                                self.makeLegends();
                            }
                        },
                        scales: {
                            yAxes: [{
                                
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(value, index, values) {
                                        let valuePrefix = value > 0 ? '+' : '';
                                        return valuePrefix + value + '% ';
                                    },
                                    stepSize: 5,
                                    suggestedMin: -10,
                                    suggestedMax: 15
                                },
                                gridLines: {
                                    display: true,
                                    color:'#b3b1b3',
                                    drawBorder : false
                                }
                            }],
                            xAxes: [{
                                barPercentage:0.7,
                                ticks: {
                                    display : false
                                },
                                gridLines: {
                                    display: false,
                                    drawBorder : false
                                }
                            }]
                        },
                        layout: {
                            padding: {
                                top: 0,
                                bottom: 0
                            }
                        },
                        legend: {
                            display: false
                        },
                        tooltips: {
                            enabled: false,
                            
                            custom: function(tooltipModel) {
                                // Tooltip Element
                                var tooltipEl = document.getElementById('chartjs-tooltip');
                                
                                var innerHtml = '';
                                
                                // Create element on first render
                                if (!tooltipEl) {
                                    tooltipEl = document.createElement('div');
                                    tooltipEl.id = 'chartjs-tooltip';
                                    tooltipEl.innerHTML = "<div></div>";
                                    document.body.appendChild(tooltipEl);
                                }
                                
                                // Hide if no tooltip
                                if (tooltipModel.opacity === 0) {
                                    tooltipEl.style.opacity = 0;
                                    return;
                                }
                                
                                // Set caret Position
                                tooltipEl.classList.remove('above', 'below', 'no-transform');
                                if (tooltipModel.yAlign) {
                                    tooltipEl.classList.add(tooltipModel.yAlign);
                                } else {
                                    tooltipEl.classList.add('no-transform');
                                }
                                
                                function getBody(bodyItem) {
                                    return bodyItem.lines;
                                }
                                
                                // Set Text
                                if (tooltipModel.body) {
                                    var titleLines = tooltipModel.title || [];
                                    var bodyLines = tooltipModel.body.map(getBody);
                                    bodyLines.forEach(function(body, i) {//value
                                        var showPlus = 1*body > 0 ? '+' : '';
                                        innerHtml += '<span style="left: calc(50% - 10px);display:block;position:absolute;top:100%;width: 0;height: 0;border-style: solid;border-width: 10px 10px 0 10px;border-color: #b3b1b3 transparent transparent transparent;"></span><b style="font-size:15px;margin-right:8px;">' + showPlus + body + '%</b>';
                                    });
                                    
                                    titleLines.forEach(function(title) {
                                        innerHtml += '<span style="font-size:13px;">' + title + '</span>';
                                    });
                                    
                                    var tableRoot = tooltipEl.querySelector('div');
                                    tableRoot.innerHTML = innerHtml;
                                }
                                
                                // `this` will be the overall tooltip
                                var position = this._chart.canvas.getBoundingClientRect();
                                
                                // Display, position, and set styles for font
                                tooltipEl.style.opacity = 1;
                                tooltipEl.style.position = 'absolute';
                                tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                                tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                                tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                                tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                                tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                                tooltipEl.style.background = '#b3b1b3';
                                tooltipEl.style.WebkitTransform = 'translate(-50%,-100%)';
                                tooltipEl.style.transform = 'translate(-50%,-100%)';
                                tooltipEl.style.margin = '-20px 0 0 0';
                                tooltipEl.style.padding = '3px 5px';
                                tooltipEl.style.borderRadius = '3px';
                                tooltipEl.style.textAlign = 'center';
                                tooltipEl.style.pointerEvents = 'none';
                                tooltipEl.style.lineHeight = '1.3';
                                tooltipEl.style.color = '#fff';
                            }
                        },
                        hover:{
                            mode:false
                        }
                    };
                    return obj;
                }
            },
            methods: {
                fillData2 (sliderValues) {
                    let minValueIndex = this.availableYears.indexOf(sliderValues[0]);
                    let maxValueIndex = this.availableYears.indexOf(sliderValues[1]);
                    maxValueIndex++;
                    let currentLabels = this.availableYears.slice(minValueIndex,maxValueIndex);
                    let currentValues = this.availableValues.slice(minValueIndex,maxValueIndex);
                    this.datacollection = {
                        labels: currentLabels,
                        datasets: [
                            {
                                backgroundColor:objMainColorsRgba.o1,
                                data: currentValues
                            }
                        ]
                    };
                },
                makeLegends(){
                    var chartInstance = this.$children[0]._data._chart,
                    ctx = chartInstance.ctx;
                    ctx.textAlign = 'center';
                    ctx.font='normal 12px sans-serif';
                    ctx.fillStyle = "rgba(0, 0, 0, 1)";
                    ctx.textBaseline = 'bottom';
                    
                    chartInstance.options.animation.duration=0;
                    
                    let currentDistanceBetweenBars = 0;
                    let distanceBetweenBars = [];
                    this.$data.datacollection.datasets.forEach(function (dataset, i) {
                        var meta = chartInstance.controller.getDatasetMeta(i);
                        
                        meta.data.forEach(function (bar, index) {
                            let distance = bar._model.x - currentDistanceBetweenBars;
                            currentDistanceBetweenBars = bar._model.x;
                            distanceBetweenBars.push(distance);
                        });
                        distanceBetweenBars.shift();
                        let averageDistance = Math.min.apply(null, distanceBetweenBars);
                        meta.data.forEach(function (bar, index) {
                            var meta = dataset._meta != undefined ? dataset._meta : bar._chart.data.datasets[0]._meta;
                            let metaObjectKey = Object.keys(meta)[0];
                            let data = dataset.data[index];
                            let positionOf0 = meta[metaObjectKey].data[index]._view.base;
                            let yPosition = data >= 0 ? positionOf0+22 : positionOf0 -8;
                            let label = meta[metaObjectKey].data[index]._model.label;
                            if(averageDistance>=13 && averageDistance<=29){
                                label = label.toString().substring(2);
                            }
                            if(averageDistance>=13 && averageDistance<=16){
                                ctx.font='normal 10px sans-serif';
                            }
                            if(averageDistance<13){
                                label='';
                            }
                            ctx.fillText(label, bar._model.x,yPosition);
                        });
                    });
                }
            }
        });
    };
}();
